import { memo, useState } from "react";
import PropTypes from "prop-types";
import AutoSuggestSearch from "../auto-suggest-search";
import HelpTooltip from "../tooltip-search";
import tooltipConstants from "../../config/content/tooltip";
import * as styled from "./style";

const HomeSearch = props => {
  const { resources, onSearchClick, onSuggestionlistopen, tourRun, tourStatus, history } = props;
  const { heading_txt } = resources;
  const [searchData, searchDataFunction] = useState([]);
  const [error, updateErrorStatus] = useState(false);
  const [termError, updateTermError] = useState(false);

  const searchDataUpdate = (val) => {
    searchDataFunction([...val]);
    if (val && val.length > 0) {
      updateErrorStatus(false);
    }
  }
  const checkError = (val) => {
    updateErrorStatus(val)
  }

  const checkTermError = (val) => {
    updateTermError(val)
  }

  const { error_logo, error_logo_alt, error_message, error_message_search_term } = resources;
  return (
    <>
      <styled.HomeSearchConatiner className="home-search">
        <styled.SearchHeading>{heading_txt}</styled.SearchHeading>
        {/* <styled.DataPharmContainer>
          <p>In Partnership with</p>
          <img src={DataPharmLogo} alt="datapharm-logo" />
        </styled.DataPharmContainer> */}
        <styled.SearchCard>
          <styled.SearchSection>
            <styled.SearchWrapper>
              <styled.SearchContainer className="searchAccordian" tourRun={tourRun}>
                <AutoSuggestSearch
                  resources={resources}
                  onSearchClick={(val, latestSearchData, keywordInput) => onSearchClick(val, latestSearchData, keywordInput)}
                  fromHomePage={true}
                  tourRun={tourRun}
                  tourStatus={tourStatus}
                  onSuggestionlistopen={val => onSuggestionlistopen(val)}
                  searchDataUpdate={(val) => searchDataUpdate(val)}
                  searchQueryData={searchData}
                  checkError={(val) => checkError(val)}
                  checkTermError={(val) => checkTermError(val)}
                  history={history}
                  error={error}
                />
              </styled.SearchContainer>
              <styled.TooltipSection>
                {
                  (error || termError) &&
                    <styled.ErrorWrapperMobile>
                      <img src={error_logo} alt={error_logo_alt}></img>
                      <p>{termError ? error_message_search_term : error_message}</p>
                    </styled.ErrorWrapperMobile>
                }
                <styled.ToolTipWrapperMobile>
                  <styled.HelpToolTipSection>
                    <HelpTooltip resources={tooltipConstants} history={history} searchError={error}></HelpTooltip>
                  </styled.HelpToolTipSection>
                </styled.ToolTipWrapperMobile>
              </styled.TooltipSection>
            </styled.SearchWrapper>
            <styled.SearchPillWrapper>
              <styled.PillWrapper error={error}>
              </styled.PillWrapper>
            </styled.SearchPillWrapper>
          </styled.SearchSection>
        </styled.SearchCard>
      </styled.HomeSearchConatiner>
    </>
  )
};

HomeSearch.propTypes = {
  resources: PropTypes.shape({
    heading_txt: PropTypes.string,
    Placeholder_txt: PropTypes.string,
    button_txt: PropTypes.string,
    icon: PropTypes.string
  }),
  onSearchClick: PropTypes.func
};

export default memo(HomeSearch);